import { Reveal } from "../../lib/motion";
import { INHERITANCE, IMAGES } from "../../lib/siteData";

export const Inheritance = () => {
  return (
    <section
      id="inheritance"
      data-testid="inheritance-section"
      className="relative py-28 lg:py-44 bg-[#0F1012] text-[#F9F8F6] overflow-hidden"
    >
      {/* faint monument backdrop */}
      <div className="absolute right-0 top-0 h-full w-1/2 opacity-[0.14] pointer-events-none" aria-hidden>
        <img src={IMAGES.marble} alt="" className="w-full h-full object-cover grayscale" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0F1012] to-transparent" />
      </div>

      <div className="relative mx-auto max-w-[1400px] px-6 lg:px-12">
        <Reveal>
          <p className="text-[11px] uppercase tracking-[0.4em] text-[#C5B498] mb-6">
            The differentiator — Inheritance Alignment
          </p>
          <h2 className="font-serif font-light tracking-tight leading-[1.0] text-[clamp(2.25rem,6vw,5.5rem)] max-w-4xl text-balance">
            Inheritance intent, governed with care.
          </h2>
          <p className="mt-8 max-w-2xl text-[#9A9C9F] text-base sm:text-lg leading-relaxed">
            During life, a person may define the values, guidance, messages, milestones, and
            inheritance intentions they wish to carry forward. EverSoul may help future
            generations understand the purpose behind that support and remain connected to
            the principles that shaped it.
          </p>
          <p className="mt-4 max-w-2xl text-[#9A9C9F] text-base sm:text-lg leading-relaxed">
            Trustees, executors, attorneys, and designated professionals retain every legal
            and financial decision.
          </p>
          <p className="mt-8 font-serif italic text-[#e6e2d8] text-xl sm:text-2xl">
            The EverSoul guides. The fiduciary governs.
          </p>
        </Reveal>

        <div className="mt-20 grid md:grid-cols-2 border-t border-[#2A2C31]">
          {INHERITANCE.map((item, i) => (
            <Reveal
              key={item.title}
              delay={(i % 2) * 0.1}
              className={`border-b border-[#2A2C31] py-10 lg:py-12 ${
                i % 2 === 0 ? "md:pr-14 md:border-r" : "md:pl-14"
              }`}
            >
              <div className="flex items-baseline gap-5">
                <span className="font-serif text-[#C5B498] text-2xl">{`0${i + 1}`}</span>
                <div>
                  <h3 className="font-serif font-light text-[clamp(1.5rem,2.4vw,2.1rem)] tracking-tight mb-3">
                    {item.title}
                  </h3>
                  <p className="text-[#9A9C9F] leading-relaxed max-w-md">{item.body}</p>
                  {item.sub && (
                    <p className="text-[#C5B498]/85 text-sm leading-relaxed max-w-md mt-3">
                      {item.sub}
                    </p>
                  )}
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-16 border border-[#C5B498]/40 rounded-sm p-7 lg:p-9 max-w-3xl bg-[#C5B498]/[0.05]">
            <p className="text-[#C5B498] text-[11px] uppercase tracking-[0.35em] mb-4">
              Important distinction
            </p>
            <p className="text-[#c8c9cc] text-[15px] leading-relaxed">
              EverSoul does not draft or replace a will, compute legal distributions, provide
              legal advice, or act as a trustee, executor, fiduciary, or decision maker.
              Governing documents and qualified human professionals retain full legal authority.
            </p>
            <p className="text-[#c8c9cc] text-[15px] leading-relaxed mt-4">
              EverSoul preserves and communicates approved values, memories, guidance,
              permissions, and intentions. It is a governed transmission layer, not an
              automated estate authority.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
